import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { clickHomeButton } from '../actions'
import Icon from 'e-submission/components/Icon'

export const MaintenancePage = () => {
  const userInfoFromLocalStorage = localStorage.getItem('userInfo')
  const agentInfo = userInfoFromLocalStorage ? JSON.parse(userInfoFromLocalStorage) : {}

  return (
    <div id="main-container">
      <div id="profile">
        <div className="media">
          <a className="media-left"></a>
        </div>
        <ul className="list-group">
          <li className="list-group-item maintenance-icon">
            <Icon.maintenance />
          </li>
          <li className="list-group-item">
            <label className={'maintenance-title-text'}>กรุณารอสักครู่</label>
            <br />
            <label className={'maintenance-title-text'}>กำลังอยู่ในระหว่างปรับปรุงระบบ</label>
          </li>
          <li className="list-group-item maintenance">
            <label className={'maintenance-detail-text'}>ขณะนี้กำลังอยู่ในระหว่างการปรับปรุงระบบ</label>
            <br />
            <label className={'maintenance-detail-text'}>จะไม่สามารถ login ได้ในขณะนี้</label>
          </li>
        </ul>
      </div>
    </div>
  )
}

const mapDispatchToProps = (dispatch) => ({
  handleHomeButtonClick: bindActionCreators(clickHomeButton, dispatch),
})
const enhance = connect(null, mapDispatchToProps)
export default enhance(MaintenancePage)
